export type LookupCategoryType = "partnerType" | "partnerVertical";

export const lookupDataSagaActionTypes = {
  callGetLookupByCategorySaga: "callGetLookupByCategorySaga",
  callCreateLookupDataSaga: "callCreateLookupDataSaga",
  callDeleteLookupDataSaga: "callDeleteLookupDataSaga",
  callLookupMappingsSaga: "callLookupMappingsSaga",
};

export type GetLookupByCategoryPayloadType = {
  category: LookupCategoryType;
  onSuccess?: () => void;
  onError?: (message: string) => void;
};

export const getLookupByCategorySagaAction: (
  payload: GetLookupByCategoryPayloadType
) => {
  type: string;
  payload: GetLookupByCategoryPayloadType;
} = (payload) => {
  return {
    type: lookupDataSagaActionTypes.callGetLookupByCategorySaga,
    payload,
  };
};

export type CreateLookupDataPayloadType = {
  category: LookupCategoryType;
  value: string;
  onSuccess?: (message: string) => void;
  onError?: (message: string) => void;
};

export const createLookupDataSagaAction: (
  payload: CreateLookupDataPayloadType
) => {
  type: string;
  payload: CreateLookupDataPayloadType;
} = (payload) => {
  return {
    type: lookupDataSagaActionTypes.callCreateLookupDataSaga,
    payload,
  };
};

export type DeleteLookupDataPayloadType = {
  ID: number;
  onSuccess?: (message: string) => void;
  onError?: (message: string) => void;
};

export const deleteLookupDataSagaAction: (
  payload: DeleteLookupDataPayloadType
) => {
  type: string;
  payload: DeleteLookupDataPayloadType;
} = (payload) => {
  return {
    type: lookupDataSagaActionTypes.callDeleteLookupDataSaga,
    payload,
  };
};

export type LookupMappingsPayloadType = {
  category: LookupCategoryType;
  module: string;
  ids: number[];
  onSuccess?: (message: string) => void;
  onError?: (message: string) => void;
};

export const lookupMappingsSagaAction: (payload: LookupMappingsPayloadType) => {
  type: string;
  payload: LookupMappingsPayloadType;
} = (payload) => {
  return {
    type: lookupDataSagaActionTypes.callLookupMappingsSaga,
    payload,
  };
};
